<template>
<div id="home">
  <my-header></my-header>
  <div class="pd20" v-if="user">
    <div class="row">
      <div class="col-md-10 mb40">
        <form v-on:submit.prevent="updateProfile">
          <h3 class="mt0">{{'Update your profile'|translate}}</h3>

          <loading v-if="loading" class="mt10" :text="'Please wait'|translate"></loading>
          <div class="row mt20" v-if="!loading">
            <div class="col-md-12" v-if="user.group">
              <p>
                {{'Member of group'|translate}} :
                <router-link :to="{ name: 'GroupProfile', params: { id: user.group.id }}">{{user.group.name}}</router-link>

              </p>
            </div>
            <div class="col-md-12 mb20">

              <!-- Nav tabs -->
              <ul class="nav nav-tabs" role="tablist">
                <li role="presentation" v-bind:class="{ active: active_tab == 'main-tab' }"><a v-on:click="active_tab ='main-tab'" aria-controls="home" role="tab" data-toggle="tab">Thông tin chính </a></li>
                <li role="presentation" v-bind:class="{ active: active_tab == 'social-tab' }"><a v-on:click="active_tab ='social-tab'" aria-controls="social-tab" role="tab" data-toggle="tab">Mạng xã hội</a></li>
                <li role="presentation" v-bind:class="{ active: active_tab == 'referral-tab' }"><a v-on:click="active_tab ='referral-tab'" aria-controls="referral-tab" role="tab" data-toggle="tab">Giới thiệu bạn bè</a></li>
                <!--                <li role="presentation" v-bind:class="{ active: active_tab == 'address-tab' }"><a v-on:click="active_tab ='address-tab'" aria-controls="address-tab" role="tab" data-toggle="tab">Địa chỉ</a></li>-->
              </ul>

              <!-- Tab panes -->
              <div class="tab-content">
                <div role="tabpanel" class="tab-pane" v-bind:class="{ active: active_tab == 'main-tab' }">

                  <div class="row mb20">
                    <div class="col-md-12 mt10">
                      <label class>{{'Name'|translate}}:</label>
                      <input v-model="user.name" ref="name" :placeholder="'Input name'|translate" class="form-control" />
                      <label class="mt20">Điện thoại: </label>
                      <input required v-model="user.vn_phone" ref="phone" disabled  :placeholder="'Input phone number'|translate" class="form-control" />
                      <label class="mt20">Mô tả:</label>

                      <wysiwyg :placeholder="'Mô tả ngắn gọn về bạn và nông trại của bạn'" v-model="user.description" :options="{maxHeight: '20px'}" />
                      <!--
                      <label class="mt20">Email: <span class="required">(*)</span></label>
                      <input type="email" required v-model="user.email" ref="email" :placeholder="'Input email'|translate" class="form-control" />
                      -->
                    </div>
                    <!-- <div class="col-md-5 mt10">
                      <div class="feature-image">
                        <p>
                          <label>Ảnh Đại Diện</label>
                        </p>
                        <div class="wrapper" v-on:click="triggerFile">
                          <img v-if="!user.feature_image_path" src="static/images/no-photo.jpg" />
                          <img v-if="user.feature_image_path" :src="user.feature_image_path" />
                          <span class="upload-icon">
                            <i class="fa fa-camera"></i>
                          </span>
                        </div>
                      </div>
                      <div>
                        <input type="file" id="file-upload" ref="file" v-on:change="handleFileUpload()" style="display:none" />
                      </div>
                    </div> -->
                  </div>

                  <selectlocation :province="user.province_id" :district="user.district_id" :commune="user.commune_id" :p_location="user.location_coord" @updateLocation="updateLocation"></selectlocation>

                </div>
                <div role="tabpanel" class="tab-pane" v-bind:class="{ active: active_tab == 'social-tab' }">
                  <label class="">Facebook:</label>
                  <input type="url" v-model="user.facebook" ref="facebook" :placeholder="'Input facebook'|translate" class="form-control" />

                  <label class="mt20">Youtube:</label>
                  <input type="url" v-model="user.youtube" ref="youtube" :placeholder="'Input youtube'|translate" class="form-control" />
                </div>
                <div role="tabpanel" class="tab-pane" v-bind:class="{ active: active_tab == 'referral-tab' }">
                  <p>
                    Link giới thiệu:
                    <a :href="user.referral_link">{{user.referral_link}}</a>
                    <a class="btn btn-primary" v-on:click="copyClipboard(user.referral_link)"  ><i class="fas fa-copy"></i> &nbsp; Copy </a>
                  </p>
                  <p>
                    Điểm: <strong>{{user.bonus_point}}</strong>
                  </p>
                  <hr/>
                  <ReferralList v-if="active_tab == 'referral-tab'" ></ReferralList>

                </div>
              </div>

              <!-- <textarea v-model="user.description" ref="introduction" rows="5" cols="50" placeholder="Mô tả về vườn của bạn" class="form-control"></textarea> -->

            </div>

          </div>
          <button class="btn btn-info mt20 mb20" type="submit" :disabled="updating">
            <i v-if="updating" class="fas fa-spinner fa-spin"></i> CẬP NHẬT
          </button>
        </form>
      </div>

      <profile-sidebar></profile-sidebar>
    </div>
  </div>
  <!-- end pd20 -->
</div>
</template>

<script>
// http://farmbook.com/API/listProduct
import Utils from '@/helpers/utils'
import MyHeader from '@/components/Layout/Header'
import AddressControl from '@/components/elements/AddressControl'
import Loading from '@/components/elements/Loading'
import selectlocation from '@/components/elements/SelectLocation'
import ReferralList from '@/components/Profile/ReferralList'

import {
  EventBus
} from '@/helpers/event-bus'
import ProfileSidebar from '@/components/Profile/ProfileSidebar'
import Config from '@/helpers/config'

export default {
  name: 'Setting',
  components: {
    MyHeader,
    Loading,
    AddressControl,
    selectlocation,
    ReferralList,
    ProfileSidebar
  },
  data () {
    return {
      loading: true,
      updating: false,
      active_tab: 'main-tab',
      user: null,
      searchparams: null,
      output: {},

      address: {},
      sent: false,
      features: Config.features,
      role: Config.role,
      response: {},
      configs: {}
    }
  },
  methods: {
    timeout (ms) {
      return new Promise(resolve => setTimeout(res, ms))
    },
    async updateProfile (event) {
      if (this.updating) return

      let data = {
        description: this.user.description,
        name: this.user.name,
        // email: this.user.email,
        facebook: this.user.facebook,
        youtube: this.user.youtube,
        id: this.user.id,
        province_id: this.user.province_id,
        district_id: this.user.district_id,
        commune_id: this.user.commune_id,
        location: this.user.location
        // phone: this.user.phone
      }

      Utils.requestV2(this, true)
        .put(`/profile/`, data)
        .then(response => {
          let data = response.data

          this.user = data
          // update local storage
          this.$localStorage.set('user', JSON.stringify(this.user))
          this.$alertify.success(this.$t('Updated profile sucessfully'))
          this.updating = false
          EventBus.$emit('updateUser', this.user)
        })
        .catch(error => {
          this.updating = false
          Utils.showErrorMessage(this, error.response)
        })
    },

    updateLocation (data) {
      for (let key in data) {
        this.user[key] = data[key]
      }
    },

    processSearchParams () {
      let searchparams = {
        address: this.user.address
      }
      if (this.user.location && this.user.location.length == 2) {
        searchparams.lat = this.user.location[0]
        searchparams.lng = this.user.location[1]
      }
      this.searchparams = searchparams
    },

    refreshProfile () {
      let wating = [Utils.requestV2(this).get(`profile`)]

      Promise.all(wating).then(values => {
        this.loading = false
        this.user = values[0].data
        // this.user.phone = this.user.phone.replace('+84','0');
        this.processSearchParams()
      })
    },
    refreshHandler (data) {
      this.user = data
    },
    copyClipboard (str) {
      const el = document.createElement('textarea')
      el.value = str
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$alertify.success(this.$t('Link đã được copy vào clipboard'))
    }
  },
  mounted () {
    let localUser = this.$localStorage.get('user')
    // console.log('localUser',localUser, typeof(localUser))
    if (localUser) {
      this.user = JSON.parse(localUser)
    } else {
      this.$router.push('/')
      return
    }

    this.refreshProfile()
    EventBus.$on('updateUser', this.refreshHandler)
  },
  beforeDestroy () {
    EventBus.$off('updateUser', this.refreshHandler)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Profile/UpdateProfile.vue